import { CIcon } from '~/icons/types'

export const ciAngleDown: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M12 15.75a.75.75 0 0 1-.53-.22l-5-5a.75.75 0 1 1 1.06-1.06L12 13.94l4.47-4.47a.75.75 0 1 1 1.06 1.06l-5 5a.75.75 0 0 1-.53.22Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'angle-down',
  type: 'light'
}
